export class InsuranceBranchProviderDTO {
  public branchId: number;

  public branch: string;

  public providerId: number;

  public providerName: string;
}
  